import React, { useState } from 'react';
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { SidebarDataLibroContable } from '../Sidebar/SideBarDataLibroContable';
import { SidebarDataUserConta } from '../Sidebar/SideBarDataUserLibroContable';
import { IconContext } from 'react-icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const defaultAvatar = require("assets/img/avatar-placeholder.png");
import MenuItems from './NavbarMenu';
import MenuItemsUser from './NavbarMenuUser';

function NavbarLibroContables(props) {
    const {
        logOut,
        user,
        empresaData,
    } = props;

    const [sidebar, setSidebar] = useState(false);
    const showSidebar = () => {
        setSidebar(!sidebar);
    }
    
    return (
        <React.Fragment>
            <IconContext.Provider value={{ color: '#fff' }}>
                <NavBar>
                    <NavIcon to="#">
                        <FaIcons.FaBars onClick={showSidebar} />
                    </NavIcon>
                    <div className="imageBoxLogo d-table m-auto">
                        <Image
                            src={require('assets/img/SIFW-LOGO-Red.png')}
                            alt="Logo" />
                    </div>
                    <div className="titleNav">
                        <Titulo>{empresaData.razon_social}</Titulo>
                    </div>
                    <div className="imageBoxLogo d-table m-auto">
                        {empresaData.logo &&
                            <ImageLogo
                                src={empresaData.logo}
                                alt="Logo" />
                        }
                    </div>
                    <NavBarMenuUser>
                        <ul className="borderUser flex-row navbar-nav">
                            {SidebarDataUserConta.map((menu, index) => {
                                return <MenuItemsUser 
                                    items={menu} 
                                    key={index} 
                                    img={(user.avatar) ? __CONFIG__.api_image + user.avatar : defaultAvatar}
                                    user={user.username}
                                    logOut={logOut}
                                />;
                            })}
                        </ul>
                    </NavBarMenuUser>
                </NavBar>
                <NavBarMenu>
                    <ul className="menus flex-row navbar-nav">
                        {SidebarDataLibroContable.map((menu, index) => {
                            return <MenuItems items={menu} key={index} />;
                        })}
                    </ul>
                </NavBarMenu>
            </IconContext.Provider>
        </React.Fragment>
    )
}

NavbarLibroContables.propTypes = {
    logOut: PropTypes.func,
    user: PropTypes.object,
    empresaData: PropTypes.object,
    moduloData: PropTypes.object,
};

export default NavbarLibroContables;

const NavBar = styled.div`
    background-color: #333;
    height: 61px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const NavBarMenu = styled.div`
    background-color: black;
    height: 45px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media (max-width: 1026px) {
        display: none;
        
    }
`;

const NavIcon = styled(Link)`
    margin-left: 2rem;
    font-size: 2rem;
    height: 61px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    display: none;
    @media (max-width: 1026px) {
        display: block;
        
    }
`;

const SidebarNav = styled.nav`
    background: #333;
    width: 250px;
    height: 100vh;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
    transition: 350ms;
    z-index: 10;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
`;

const SiderbarWrap = styled.div`
    width: 250px;
`;

const NavBarMenuUser = styled.div`
    background-color: black;
    height: 61px;
    width: 450px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const Titulo = styled.div`
    color: white;
    padding-top: 5px;
    padding-left: 10px;
    font-weight: bold;
    font-size: 1.5rem;
    @media (max-width: 985px) {
        display: none;
        
    }
`;

const Image = styled.img`
    max-width: 100%;
    max-height: 100%;
    display: inline-block;
    position: absolute;
    @media (max-width: 985px) {
        display: none;
        
    }
`;

const ImageLogo = styled.img`
    max-width: 100%;
    max-height: 100%;
    display: inline-block;
    position: absolute;
    bottom: 0;
    margin: 0 auto;
    left: 0;
    right: 0;
    @media (max-width: 985px) {
        display: none;
    }
`;
